import React from 'react';

const FileSizeLimitModal = ({ isOpen, onClose, fileSize }) => {
    if (!isOpen) return null;

    const fileSizeMB = (fileSize / (1024 * 1024)).toFixed(1);

    const handleBackdropClick = (e) => {
        if (e.target === e.currentTarget) {
            onClose();
        }
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Escape') {
            onClose();
        }
    };

    return (
        <div
        className="modal-overlay"
        onClick={handleBackdropClick}
        onKeyDown={handleKeyDown}
        tabIndex={-1}
        >
        <div className="modal-content" style={{ maxWidth: '500px', padding: '30px' }}>
        <h2 style={{ marginBottom: '20px', fontSize: '24px', fontWeight: '600' }}>
        Plik przekracza maksymalny limit
        </h2>

        <div className="alert alert-warning" style={{ marginBottom: '20px' }}>
        <strong>Rozmiar pliku: {fileSizeMB} MB</strong><br />
        Maksymalny limit: 100 MB
        </div>

        <p style={{ marginBottom: '20px', lineHeight: '1.6', color: '#555' }}>
        Aby przetworzyć tak duży plik, prosimy o przesłanie go przez serwis transferowy
        (np. <strong>WeTransfer</strong>, <strong>Google Drive</strong>) i wysłanie linku na adres:
        </p>

        <div style={{
            padding: '12px',
            backgroundColor: '#f8f9fa',
            borderRadius: '6px',
            marginBottom: '20px',
            textAlign: 'center',
            fontFamily: 'monospace',
            fontSize: '16px',
            fontWeight: '600',
            color: '#F53447'
        }}>
        rfq@gh3d.pl
        </div>

        <p style={{ fontSize: '14px', color: '#666', marginBottom: '25px' }}>
        Skontaktujemy się z Tobą w celu omówienia szczegółów wyceny.
        </p>

        <button
        className="btn btn-primary"
        style={{ width: '100%', padding: '12px' }}
        onClick={onClose}
        >
        Rozumiem
        </button>
        </div>
        </div>
    );
};

export default FileSizeLimitModal;
